export default {
  planningitems: [],
  lastItemKeys: {
    past: null,
    all: null,
    week: null
  }
}
